// extracted by mini-css-extract-plugin
module.exports = {"hotspotLayer":"HotspotLayer_hotspotLayer__1ub_7 width-100 position-relative","annotationMode":"HotspotLayer_annotationMode__PtaB- cusror-crosshair"};